import _ from 'lodash';
import produce from 'immer';
import create from 'zustand';

const plainMapper = value => ({ value, label: value });
const cMapper = d => ({ label: d.name, value: d.id });
const buildQMapper = cats => q => ({
  ...q,
  category: _.find(cats.map(cMapper), { label: q.category }),
  fundTypes: _.map(q.fundTypes, plainMapper),
});

const useStore = create(set => ({
  highlightType: null,
  qs: [],
  cats: [],
  setQsCats: (qs, cats) => set(() => ({
    cats: cats.map(cMapper),
    qs: _(qs).map(buildQMapper(cats)).sortBy(['order', 'id']).value(),
  })),
  set: fn => set(produce(fn)),
}));

export default useStore;
